import ScalarCodeBlock_default from "./ScalarCodeBlock.vue.js";
import ScalarCodeBlockCopy_default from "./ScalarCodeBlockCopy.vue.js";
export { ScalarCodeBlock_default as ScalarCodeBlock, ScalarCodeBlockCopy_default as ScalarCodeBlockCopy };
